import { queryOptions } from '@tanstack/react-query';
import { createServerFn } from '@tanstack/react-start';

import type { Conversation } from '~ai-tutor/lib/ddb/conversations';

import type { Session } from '../../ddb/sessions';

type EventData = {
  id: string;
  title: string;
};

export type GetCurrentUserResult =
  | { authenticated: false }
  | {
      authenticated: true;
      identityType: 'token';
      session: Session;
      conversationId?: string;
      currentConversation?: Conversation;
      events: EventData[];
    }
  | {
      authenticated: true;
      identityType: 'oidc';
      userId: string;
      email: string;
      name?: string;
      familyName?: string;
      events: EventData[];
      conversationId?: string;
      currentConversation?: Conversation;
      sessionId: string;
    };

export const getCurrentUserFn = createServerFn({ method: 'GET' }).handler(async () => {
  const { getCurrentUser } = await import('./currentUser.server');
  return getCurrentUser();
});

export const currentUserQueryOptions = () =>
  queryOptions({
    queryKey: ['currentUser'],
    queryFn: (): Promise<GetCurrentUserResult> => getCurrentUserFn(),
  });
